import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductCard from './ProductCard';
import MobileProductCard from './MobileProductCard';
import './ProductGrid.css';
import { Product } from '../features/products/productModels';
import { CategoryProduct } from '../features/categories/categoryModels';
interface ProductGridProps {
  products: Product[]|CategoryProduct[]|any[];
  onAddToCart: any;
  onToggleWishlist: (productId: number) => void;
  wishlistItems: any[];
  title?: string;
  showFilters?: boolean;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  products,
  onAddToCart,
  onToggleWishlist,
  wishlistItems,
  title,
  showFilters = false
}) => {
  const { t } = useTranslation();
  const [sortBy, setSortBy] = useState('featured');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  console.log("products-grid",products);
  console.log("wishlistItems",wishlistItems);
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const sortedProducts = [...products].sort((a, b) => {
    switch (sortBy) {
      case 'price-low':
        return a.price - b.price;
      case 'price-high':
        return b.price - a.price;
      default:
        return 0;
    }
  });

  return (
    <div className="product-grid-container">
     
      {/* Results Count */}
      <div className="results-info">
        <span className="results-count">
          {t('productGrid.showingProducts', { count: sortedProducts.length })}
        </span>
      </div>

      {/* Product Grid */}
      <div className={`product-grid ${viewMode}`}>
        {sortedProducts.map((product) => 
          isMobile ? (
            <MobileProductCard
              key={product._id}
              product={product}
              onAddToCart={onAddToCart}
              onToggleWishlist={onToggleWishlist}
              isInWishlist={wishlistItems.includes(product._id)}
            />
          ) : (
            <ProductCard
              key={product._id}
              product={product}
              onAddToCart={onAddToCart}
              onToggleWishlist={onToggleWishlist}
              isInWishlist={wishlistItems.includes(product._id)}
            />
          )
        )}
      </div>

      {/* Load More Button */}
      {sortedProducts.length > 0 && (
        <div className="load-more-container">
          <button className="load-more-button">
            {t('productGrid.loadMoreProducts')}
          </button>
        </div>
      )}

      {/* Empty State */}
      {sortedProducts.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">🔍</div>
          <h3>{t('productGrid.noProductsFound')}</h3>
          <p>{t('productGrid.tryAdjustingSearch')}</p>
        </div>
      )}
    </div>
  );
};

export default ProductGrid;
